import type {
  Warehouse,
  WarehouseStatusEnum,
} from '../shared/types';
import {
  WarehouseSchema,
  EntityBase,
  EntityType,
  WarehouseStatus
} from '../shared/types';
import { z } from 'zod';

const versionOne = 1;

export class WarehouseEntity {

  private constructor(private readonly props: Warehouse) { }

  static create(props: Omit<Warehouse, keyof z.infer<typeof EntityBase>>): WarehouseEntity {
    const now = new Date();
    const warehouse = WarehouseSchema.parse({
      ...props,
      _id: EntityType.enum.warehouse + globalThis.crypto.randomUUID(),
      type: EntityType.enum.warehouse,
      version: versionOne,
      createdAt: now,
      updatedAt: now,
    });
    return new WarehouseEntity(warehouse);
  }

  static restore(data: Warehouse): WarehouseEntity {
    return new WarehouseEntity(WarehouseSchema.parse(data));
  }

  get _id(): string {
    return this.props._id;
  }

  get _rev(): string | undefined {
    return this.props._rev;
  }

  get type(): string {
    return this.props.type;
  }

  get version(): number {
    return this.props.version;
  }

  get createdAt(): Date {
    return this.props.createdAt;
  }

  get updatedAt(): Date {
    return this.props.updatedAt;
  }

  get name(): string {
    return this.props.name;
  }

  get status(): WarehouseStatusEnum {
    return this.props.status;
  }

  activate(): void {
    this.props.status = WarehouseStatus.enum.ACTIVE;
    this.props.updatedAt = new Date();
  }

  deactivate(): void {
    this.props.status = WarehouseStatus.enum.INACTIVE;
    this.props.updatedAt = new Date();
  }

  updateName(name: string): void {
    this.props.name = name;
    this.props.updatedAt = new Date();
  }

  toJSON(): Warehouse {
    return { ...this.props };
  }
}
